<div class="reset-password">
  <div class="container reset-password-container">
    <div class="container-header no-bottom-border">
      <div class="text">Reset Password</div>
    </div>
    <div *ngIf="!passwordReset" class="container-content">
      <div class="container-row">
        <lhpe-input
          class="input"
          controlName="newPassword"
          placeholder="New Password"
          [formGroup]="resetPasswordForm"
          type="password"
        >
        </lhpe-input>
      </div>
      <div class="container-row">
        <lhpe-input
          class="input"
          controlName="confirmNewPassword"
          placeholder="Confirm New Password"
          [formGroup]="resetPasswordForm"
          type="password"
        >
        </lhpe-input>
      </div>

      <div class="container-row submit-row">
        <button
          mat-button
          color="lightGreen"
          [disabled]="resetPasswordForm.invalid"
          (click)="submitNewPassword()"
        >
          Submit
        </button>
      </div>
    </div>
    <div *ngIf="passwordReset" class="container-content">
      <div class="container-row desc-row">
        Password reset succesfully, please wait as we redirect you to the login
        page
      </div>
    </div>
  </div>
</div>
